/* LA BARRA DELLA SELEZIONE, sopra e sotto la lista.
 *
 * Mostra chi è già nel confronto, permette di toglierlo e porta alla pagina.
 * Compare solo quando qualcosa è selezionato: a selezione vuota sarebbe una
 * riga di interfaccia che non dice niente, e le caselle con «Metti nel
 * confronto» scritto accanto si spiegano da sole.
 *
 * PERCHÉ DUE COPIE E NON UNA AGGANCIATA IN BASSO. `sb-cornice` ha
 * `overflow: hidden`, quindi dentro di lei `position: sticky` non ha un
 * contenitore a cui agganciarsi. Chi spunta la seconda casella a metà pagina
 * deve poter premere «Confronta» senza risalire in cima: ripetere la barra dopo
 * la paginazione è l'unico modo che non richieda di sapere quanto è alta la
 * finestra — e sapere quanto è alta la finestra è esattamente ciò che una
 * schermata non deve fare in JavaScript.
 */

import { Distintivo, Pulsante } from '../../componenti';
import { num, timeframe } from '../../lib/formato';
import type { RigaBacktest } from './ListaBacktest';
import { MINIMO_CONFRONTO, TETTO_CONFRONTO } from './statoConfronto';
import './backtest.css';

export function BarraConfronto({
  selezionati,
  righe,
  onTogli,
  onSvuota,
  onConfronta,
}: {
  selezionati: number[];
  /** Le righe a schermo: servono a scrivere il nome accanto all'identificativo. */
  righe: RigaBacktest[];
  onTogli: (id: number) => void;
  onSvuota: () => void;
  onConfronta: () => void;
}) {
  if (selezionati.length === 0) return null;

  const pronto = selezionati.length >= MINIMO_CONFRONTO;

  return (
    <div className="sb-bt-barra">
      <div className="sb-bt-barra__voci">
        {selezionati.map((id) => {
          /* La riga può non essere nella pagina corrente: la selezione vive
             nell'URL e sopravvive a filtri e paginazione. In quel caso si mostra
             l'identificativo nudo, che è quello che sappiamo per certo —
             inventare un nome sarebbe peggio che non averlo. */
          const r = righe.find((x) => x.id === id);
          return (
            <button
              key={id}
              type="button"
              className="sb-pastiglia"
              onClick={() => onTogli(id)}
              title={`Togli #${id} dal confronto`}
            >
              <span className="sb-pastiglia__chiave">#{id}</span>
              <span className="sb-pastiglia__valore">
                {r ? `${r.strategia} · ${r.asset} ${timeframe(r.candleSize)}` : 'fuori da questa pagina'}
              </span>
              <span className="sb-pastiglia__chiudi" aria-hidden="true">
                ×
              </span>
            </button>
          );
        })}
      </div>

      <div className="sb-bt-barra__azioni">
        {/* Il conteggio dice anche il tetto, sempre: chi ha quattro caselle
            spuntate deve sapere perché la quinta non entra PRIMA di provarci. */}
        <Distintivo tono={selezionati.length >= TETTO_CONFRONTO ? 'cautela' : 'accento'}>
          {num(selezionati.length)} su {TETTO_CONFRONTO}
          {selezionati.length >= TETTO_CONFRONTO ? ' · pieno' : ''}
        </Distintivo>
        <Pulsante variante="nudo" onClick={onSvuota}>
          Svuota
        </Pulsante>
        <Pulsante variante="primario" onClick={onConfronta} disabled={!pronto}>
          {pronto ? `Confronta i ${num(selezionati.length)}` : 'Scegline almeno due'}
        </Pulsante>
      </div>
    </div>
  );
}
